import React, { useState } from 'react'
import QRCode from 'react-qr-code'
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { useParams } from 'react-router'
import styles from './ShareResume.module.css'
import { IoMdShare } from "react-icons/io";
import { FaLink } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { RWebShare } from "react-web-share";





const ShareResume = () => {
    const { userIdentifier } = useParams()
    const qrVal = `https://cv.stylelink.in/${userIdentifier}`
    const [isDownloading, setIsDownloading] = useState(false)
    const [hasCopied, setHasCopied] = useState(false)
    const [color, setColor] = useState('')

    const downloadQRCode = () => {
        setIsDownloading(true)
        domtoimage.toBlob(document.getElementById(`qrContent`))
            .then(function (blob) {
                saveAs(blob, `${userIdentifier}.png`);
            });
        setIsDownloading(false)
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(qrVal)
            .then(() => {
                setHasCopied(true);
                setTimeout(() => setHasCopied(false), 5000); // Reset after 2 seconds
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };

    const generateColor = () => {
        setColor(setRandomGradient())
    }



    function setRandomGradient(elementId) {
        function getRandomHexColor() {
            let color;
            do {
                color = Math.floor(Math.random() * 16777215).toString(16);
            } while (color.length < 6);
            return `#${color}`;
        }

        function isDarkColor(hex) {
            // Convert hex to RGB
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            // Calculate luminance
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            // Return true if the color is dark
            return luminance < 0.5;
        }

        function getRandomDarkHexColor() {
            let color;
            do {
                color = getRandomHexColor();
            } while (!isDarkColor(color));
            return color;
        }

        const color1 = getRandomDarkHexColor();
        const color2 = getRandomDarkHexColor();
        const gradient = `linear-gradient(45deg, ${color1}, ${color2})`;

        const element = document.getElementById('mainContainer');
        if (element) {
            element.style.backgroundImage = gradient;
            document.getElementById("generateColorBtn").style.backgroundImage = gradient;
        }

        return gradientToHex(color1, color2)


    }

    // Usage example:
    // Ensure there is an element with id "gradient-background" in your HTML
    //   setRandomGradient('gradient-background');

    function gradientToHex(color1, color2) {
        function hexToRgb(hex) {
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return { r, g, b };
        }

        function rgbToHex(r, g, b) {
            return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
        }

        function averageColor(color1, color2) {
            const rgb1 = hexToRgb(color1);
            const rgb2 = hexToRgb(color2);
            const avgR = Math.round((rgb1.r + rgb2.r) / 2);
            const avgG = Math.round((rgb1.g + rgb2.g) / 2);
            const avgB = Math.round((rgb1.b + rgb2.b) / 2);
            return rgbToHex(avgR, avgG, avgB);
        }

        return averageColor(color1, color2);
    }

    // // Usage example:
    // const color1 = "#3498db";
    // const color2 = "#e74c3c";
    // const averageHex = gradientToHex(color1, color2);
    // console.log(averageHex);  // Outputs the averaged hex color



    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer} id="mainContainer">
                <div className={styles.mainContent}>
                    <div className={styles.headerWrapper}>
                        <div className={styles.headerTitle}>
                            People can scan this to see your resume.
                        </div>
                        <div className={styles.generateColorWrapper}>
                            <button onClick={() => generateColor()}
                                className={styles.generateColorBtn}
                                id="generateColorBtn"
                            >

                            </button>
                        </div>
                    </div>
                    <div className={styles.bodyWrapper}>
                        <div className={styles.qrWrapper}>
                            <div className={styles.qrContainer} onClick={() => generateColor()}>
                                <div className={styles.qrContent} id="qrContent">
                                    <div className={styles.qrCodeWrapper}>
                                        <QRCode
                                            size={256}
                                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                            value={qrVal}
                                            viewBox={`0 0 300 300`}
                                            bgColor="transparent"
                                            fgColor={color}
                                            level='L'
                                        />
                                    </div>
                                    <div className={styles.usernameWrapper}>
                                        <div className={styles.usernameTxt}>
                                            @{userIdentifier}
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className={styles.actionWrapper}>
                            <div className={styles.actionContainer}>
                                <div className={styles.actionContent}>
                                    <RWebShare
                                        data={{
                                            text: "Hi, I'm available on stylelink.in you can check my resume here!",
                                            url: qrVal,
                                            title: "See My Professional Resume",
                                        }}
                                        onClick={() => console.log("shared successfully!")}
                                    >
                                        <div className={styles.eachActionWrapper}>
                                            <div className={styles.actionIcon}>
                                                <IoMdShare size={30} />
                                            </div>
                                            <div className={styles.actionTitle}>
                                                Share Resume
                                            </div>
                                        </div>
                                    </RWebShare>

                                    <div className={styles.eachActionWrapper} onClick={() => handleCopy()}>
                                        <div className={styles.actionIcon}>
                                            <FaLink size={30} />
                                        </div>
                                        <div className={styles.actionTitle}>
                                            {hasCopied===false ? `Copy Link` : 'Copied!'}
                                        </div>
                                    </div>
                                    <div className={styles.eachActionWrapper} onClick={() => downloadQRCode()} >
                                        <div className={styles.actionIcon}>
                                            <FiDownload size={30} />
                                        </div>
                                        <div className={styles.actionTitle}>
                                            {isDownloading === true ? `Downloading...` : `Download`}
                                        </div>
                                    </div>



                                </div>

                            </div>

                        </div>
                    </div>
                    <div className={styles.footerWrapper}>
                        <div className={styles.viewResumeWrapper}>
                            <Link to={`/${userIdentifier}`}>
                                View Resume
                            </Link>
                        </div>
                        <div className={styles.poweredLineWrapper}>
                            Powered By Stylelink
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShareResume